/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_errors_500_message = /** @type {(inputs: {}) => string} */ () => {
	return `Na serveru došlo k chybě. Prosím zkuste později.`
};

const da_errors_500_message = /** @type {(inputs: {}) => string} */ () => {
	return `Der opstod en fejl på serveren. Prøv venligst igen senere.`
};

const de_errors_500_message = /** @type {(inputs: {}) => string} */ () => {
	return `Auf dem Server ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.`
};

const en_errors_500_message = /** @type {(inputs: {}) => string} */ () => {
	return `An internal server error occurred. Please try again later.`
};

const es_errors_500_message = /** @type {(inputs: {}) => string} */ () => {
	return `Se produjo un error en el servidor. Por favor, inténtalo más tarde.`
};

const fr_errors_500_message = /** @type {(inputs: {}) => string} */ () => {
	return `Une erreur s'est produite sur le serveur. Veuillez réessayer plus tard.`
};

const hu_errors_500_message = /** @type {(inputs: {}) => string} */ () => {
	return `Hiba történt a szerveren. Kérjük, próbálkozz később.`
};

const it_errors_500_message = /** @type {(inputs: {}) => string} */ () => {
	return `Si è verificato un errore sul server. Riprova più tardi.`
};

const nl_errors_500_message = /** @type {(inputs: {}) => string} */ () => {
	return `Er is een fout opgetreden op de server. Probeer het later opnieuw.`
};

const pl_errors_500_message = /** @type {(inputs: {}) => string} */ () => {
	return `Wystąpił błąd serwera. Spróbuj ponownie później.`
};

const pt_errors_500_message = /** @type {(inputs: {}) => string} */ () => {
	return `Ocorreu um erro no servidor. Por favor, tente novamente mais tarde.`
};

const sv_errors_500_message = /** @type {(inputs: {}) => string} */ () => {
	return `Ett fel uppstod på servern. Försök igen senare.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const errors_500_message = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.errors_500_message(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("errors_500_message", locale)
	if (locale === "cs") return cs_errors_500_message(inputs)
	if (locale === "da") return da_errors_500_message(inputs)
	if (locale === "de") return de_errors_500_message(inputs)
	if (locale === "en") return en_errors_500_message(inputs)
	if (locale === "es") return es_errors_500_message(inputs)
	if (locale === "fr") return fr_errors_500_message(inputs)
	if (locale === "hu") return hu_errors_500_message(inputs)
	if (locale === "it") return it_errors_500_message(inputs)
	if (locale === "nl") return nl_errors_500_message(inputs)
	if (locale === "pl") return pl_errors_500_message(inputs)
	if (locale === "pt") return pt_errors_500_message(inputs)
	return sv_errors_500_message(inputs)
};
export { errors_500_message as "errors.500.message" }